import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b338f50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "img-wrapper xag-flex-center"
}
const _hoisted_2 = { class: "guide-view-button xag-flex-col xag-page__footer device-replace-button-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开始参与活动前，请仔细查询 ", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "xag-ellipsis" }
const _hoisted_9 = { class: "sn" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "no-data-box xag-flex-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "device-no-data-icon replace-v3-icon" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record-no-data-tips" }, "暂无申请记录", -1))
const _hoisted_14 = { class: "device-replace-button-wrap" }
const _hoisted_15 = { class: "popup-content img-wrapper xag-flex-center" }
const _hoisted_16 = { class: "guide-view-button xag-flex-col xag-page__footer device-replace-button-wrap" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可点击查询 ", -1))
const _hoisted_18 = {
  key: 2,
  class: "form-footer xag-page__footer device-replace-button-wrap"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import { RecordItem } from '@/types/device-replace-v3'
import {
  getApplyRecordList,
  getUserGuideStatus,
  updateUserGuideStatus,
} from '@/apis/device-replace-v3'
import { useRouter, Router } from 'vue-router'
import { List, PullRefresh, Button, Toast, Dialog, Popup } from 'vant'
import appHost from '@/utils/app'
import { statusColorMap, payStatusTextMap, activityStart, activityEnd } from './definition'
import { AxiosError } from 'axios'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'record-list',
  setup(__props) {

const $router: Router = useRouter()
let onLeftClick = function () {
  appHost.goAppBack()
}

const guideViewedCacheKey = 'DeviceReplaceGuideViewedCacheKey'
function setDataCache() {
  // 设置数据缓存
  sessionStorage.setItem(
    guideViewedCacheKey,
    JSON.stringify({
      guideViewed: guideViewed.value,
    })
  )
}

function initPageData() {
  fetchGuideViewStatus()
}

const activityInfoPopupShow = ref(false)

const guideViewed = ref(true) // 指引是否已浏览
async function fetchGuideViewStatus() {
  // 获取数据缓存
  let data
  let guideViewedJson = sessionStorage.getItem(guideViewedCacheKey)
  if (guideViewedJson) {
    const guideViewedData = JSON.parse(guideViewedJson)
    data = guideViewedData.guideViewed
    sessionStorage.removeItem(guideViewedCacheKey)
  } else {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
    })
    try {
      let result = await getUserGuideStatus()
      data = Boolean(Number(result.count))
    } catch (error) {}
    Toast.clear()
  }
  // guideViewed.value = data
  if (guideViewed.value) {
    setTimeout(() => {
      // activityInfoPopupShow.value = true
    }, 300)
  }
}
// 更新浏览状态
async function updateGuideViewStatus() {
  try {
    await updateUserGuideStatus()
    guideViewed.value = true
  } catch (error) {}
}

const recordList = ref([])
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)
const requestError = ref(false)
const queryParams = {
  p: 0,
  psize: 20,
}

const queryList = async (overwrite = false) => {
  queryParams.p++
  try {
    let data = await getApplyRecordList(queryParams)
    const formatData = data.data.map((item) => ({
      ...item,
      status_text:
        item.status === 11 || item.status === 3
          ? payStatusTextMap.get(item.pay_status)
          : item.status_text,
      statusBgColor: statusColorMap.get(item.status + ''),
    }))
    if (overwrite) {
      recordList.value = formatData
    } else {
      recordList.value = recordList.value.concat(formatData)
    }
    console.log(
      'recordList.value',
      [...recordList.value].map((item) => ({ ...item }))
    )
    finished.value = recordList.value.length >= Number(data.recordCount)
  } catch (error) {
    console.log('error', error)
    queryParams.p = 0
    requestError.value = true
    if ((error as { status: number }).status === 4304) {
      Toast.fail('登录失效,请重新登录后重试')
    } else {
      Toast.fail((error as AxiosError)?.message || '网络连接错误，请稍后再试')
    }
  }
  loading.value = false
  refreshing.value = false
}
function recordItemClick(item: RecordItem) {
  $router.push({ name: 'device-replace-v3-record-detail', query: { guid: item.guid } })
}
function getInfoImageStyle(item: RecordItem) {
  return `background-image: url(${item.brand_img})`
}

function isOverTime() {
  return dayjs(activityStart).valueOf() > Date.now() || Date.now() > dayjs(activityEnd).valueOf()
}
function toAddApply() {
  if (!guideViewed.value) {
    updateGuideViewStatus()
  }
  // if (isOverTime()) {
  //   // 非活动时间
  //   return Dialog({
  //     message: '目前非活动期间，无法提交申请，如需参与后续活动，可关注极飞科技官方公众号的活动通知',
  //     confirmButtonText: '我知道了',
  //     className: 'device-replace-v3-dialog',
  //     allowHtml: true,
  //     width: 304,
  //   })
  // }
  setDataCache()
  $router.push({ name: 'device-replace-v3-apply-form' })
}
const onRefresh = () => {
  queryParams.p = 0
  queryList(true)
}
function checkProtocol() {
  setDataCache()
  $router.push({ name: 'device-replace-v3-activity-notification' })
}

initPageData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "优惠购机活动",
      isReturnLeftEvent: "",
      onLeftClick: _unref(onLeftClick)
    }, null, 8, ["onLeftClick"]),
    (!guideViewed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", { class: "tips" }, [
              _hoisted_3,
              _createElementVNode("span", {
                class: "protocol",
                onClick: checkProtocol
              }, "《活动细则》")
            ]),
            _createVNode(_unref(Button), {
              square: "",
              type: "success",
              class: "xa-vant-button",
              onClick: toAddApply
            }, {
              default: _withCtx(() => [
                _createTextVNode("立即开始")
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createBlock(_unref(PullRefresh), {
          key: 1,
          modelValue: refreshing.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refreshing).value = $event)),
          onRefresh: onRefresh,
          class: "list-wrap"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(List), {
              loading: loading.value,
              "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
              error: requestError.value,
              "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((requestError).value = $event)),
              finished: finished.value,
              "finished-text": "没有更多了",
              "error-text": "加载失败",
              onLoad: queryList,
              class: "list-container"
            }, {
              finished: _withCtx(() => [
                (recordList.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, "没有更多了"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _hoisted_12,
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_unref(Button), {
                            square: "",
                            type: "success",
                            class: "xa-vant-button",
                            onClick: toAddApply
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("添加申请")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.guid,
                    class: _normalizeClass(["list-item", index === 0 ? '' : 'mt16']),
                    onClick: ($event: any) => (recordItemClick(item))
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, _toDisplayString(item.sn), 1),
                      _createElementVNode("div", {
                        class: "status-wrap",
                        style: _normalizeStyle('color:' + item.statusBgColor)
                      }, _toDisplayString(item.status_text), 5),
                      _hoisted_5
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: "img",
                        style: _normalizeStyle(getInfoImageStyle(item))
                      }, null, 4),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.brand_text), 1),
                        _createElementVNode("div", _hoisted_9, "机型：" + _toDisplayString(item.model), 1)
                      ])
                    ])
                  ], 10, _hoisted_4))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "error", "finished"])
          ]),
          _: 1
        }, 8, ["modelValue"])),
    _createVNode(_unref(Popup), {
      show: activityInfoPopupShow.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((activityInfoPopupShow).value = $event)),
      round: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", { class: "tips" }, [
              _hoisted_17,
              _createElementVNode("span", {
                class: "protocol",
                onClick: checkProtocol
              }, "《活动细则》")
            ]),
            _createVNode(_unref(Button), {
              square: "",
              type: "success",
              class: "xa-vant-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (activityInfoPopupShow.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("我知道了")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    (recordList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_unref(Button), {
            square: "",
            type: "success",
            class: "xa-vant-button",
            onClick: toAddApply
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加申请")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _hoisted_19
  ], 64))
}
}

})